import { render } from "./CboView.vue?vue&type=template&id=fb0330a0&scoped=true"
import script from "./CboView.vue?vue&type=script&lang=js"
export * from "./CboView.vue?vue&type=script&lang=js"

import "./CboView.vue?vue&type=style&index=0&id=fb0330a0&lang=scss&scoped=true"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0330a0"]])

export default __exports__